import Grid from '@mui/material/Grid';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useDirectoryModel } from '../Model/DirectoryModel';
import { useInlineEditor } from '../Hooks/useInlineEditor';
import { PersonEditorProps } from './PersonEditorProps';
import { useEthnicities } from '../Model/ConfigurationModel';

export function EthnicityEditor({ familyId, person }: PersonEditorProps) {
  const ethnicities = useEthnicities();
  const directoryModel = useDirectoryModel();

  const editor = useInlineEditor(
    async (ethnicity) =>
      await directoryModel.updatePersonEthnicity(
        familyId!,
        person.id!,
        ethnicity
      ),
    person.ethnicity!
  );

  return (
    <Grid container spacing={2}>
      {editor.editing ? (
        <>
          <Grid size={12}>
            <FormControl required fullWidth size="small">
              <InputLabel id="ethnicity-label">Ethnicity</InputLabel>
              <Select
                labelId="ethnicity-label"
                label="Ethnicity"
                id="ethnicity"
                value={editor.value || ''}
                onChange={(e) => editor.setValue(e.target.value as string)}
              >
                <MenuItem key="placeholder" value="" disabled>
                  Select an ethnicity
                </MenuItem>
                {ethnicities.map((ethnicity) => (
                  <MenuItem key={ethnicity} value={ethnicity}>
                    {ethnicity}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12}>
            {editor.cancelButton}
            {editor.saveButton}
          </Grid>
        </>
      ) : (
        <Grid size={12}>
          Ethnicity: {person.ethnicity}
          {editor.editButton}
        </Grid>
      )}
    </Grid>
  );
}
